export var SubscriptionManagerEvent;
(function (SubscriptionManagerEvent) {
    SubscriptionManagerEvent["DidFetchSubscription"] = "Subscription:DidFetchSubscription";
})(SubscriptionManagerEvent || (SubscriptionManagerEvent = {}));
